import React, { useState } from "react"
import style from "./contact.module.scss"

function Contact() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  function submitHandler(event) {
    // event.preventDefault();
    console.log('name: ', name, 'email: ', email, 'phone', phone, 'message', message);
  }

  const iframeContact = () => {
    return {
      __html: `<iframe
                 src="https://link.trustdrivencare.com/widget/form/31tmgx6jzadzdSJUqad3"
                 style="width:653px;height:1180px;border:none;border-radius:3px"
                 id="inline-31tmgx6jzadzdSJUqad3" 
                 data-layout="{'id':'INLINE'}"
                 data-trigger-type="alwaysShow"
                 data-trigger-value=""
                 data-activation-type="alwaysActivated"
                 data-activation-value=""
                 data-deactivation-type="neverDeactivate"
                 data-deactivation-value=""
                 data-form-name="Acupuncture Insurance Verification"
                 data-height="1061"
                 data-layout-iframe-id="inline-31tmgx6jzadzdSJUqad3"
                 data-form-id="31tmgx6jzadzdSJUqad3"
                 title="Acupuncture Insurance Verification">
                </iframe>
               <script src="https://link.trustdrivencare.com/js/form_embed.js"></script>`
    }
  }
  return (
      <div className={`${style.contact} container`} id="contacts">
        <h2 className={style.contact__title}>CONTACT</h2>
              <div className={style.contact__general}>
                <h3 className={`${style.contact__generalItem} ${style.contact__otherTitle}`}>GENERAL INQUIRIES</h3>
                <a className={style.contact__generalItem} href="mailto:&#104;&#101;&#108;&#108;&#111;&#64;&#97;&#99;&#117;&#98;&#111;&#115;&#116;&#111;&#110;&#46;&#99;&#111;&#109;">&#104;&#101;&#108;&#108;&#111;&#64;&#97;&#99;&#117;&#98;&#111;&#115;&#116;&#111;&#110;&#46;&#99;&#111;&#109;</a>
                <a className={style.contact__generalItem} href="tel:+16178602039">tel: 1-617-860-2039</a>
                <a className={style.contact__generalItem} href="fax:+16178602039">fax: 1-617-608-2836</a>
              </div>


        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}
             dangerouslySetInnerHTML={iframeContact()} />
        {/*<div className={style.contact__body}>*/}
        {/*  <div className={style.contact__other}>*/}
        {/*    <h3 className={style.contact__otherTitle}>ALL OTHER INQUIRIES</h3>*/}
        {/*    <form method="POST" action="/cgi-bin/contact.plx">*/}
        {/*      <div className={style.contact__formItem}>*/}
        {/*        <input*/}
        {/*          className={style.contact__formInput}*/}
        {/*          id="form-name"*/}
        {/*          name="name"*/}
        {/*          type="text"*/}
        {/*          placeholder=" "*/}
        {/*          onChange={event => setName(event.target.value)}*/}
        {/*        />*/}
        {/*        <label*/}
        {/*          className={style.contact__formLabel}*/}
        {/*          htmlFor="form-name"*/}
        {/*        >*/}
        {/*          Full name*/}
        {/*        </label>*/}
        {/*      </div>*/}

        {/*      <div className={style.contact__formItem}>*/}
        {/*        <input*/}
        {/*          className={style.contact__formInput}*/}
        {/*          id="form-email"*/}
        {/*          type="email"*/}
        {/*          name="email"*/}
        {/*          placeholder=" "*/}
        {/*          onChange={event => setEmail(event.target.value)}*/}
        {/*        />*/}
        {/*        <label*/}
        {/*          className={style.contact__formLabel}*/}
        {/*          htmlFor="form-email"*/}
        {/*        >*/}
        {/*          Email*/}
        {/*        </label>*/}
        {/*      </div>*/}

        {/*      <div className={style.contact__formItem}>*/}
        {/*        <input*/}
        {/*          className={style.contact__formInput}*/}
        {/*          id="form-phone"*/}
        {/*          type="tel"*/}
        {/*          name="phone"*/}
        {/*          placeholder=" "*/}
        {/*          onChange={event => setPhone(event.target.value)}*/}
        {/*        />*/}
        {/*        <label*/}
        {/*          className={style.contact__formLabel}*/}
        {/*          htmlFor="form-phone"*/}
        {/*        >*/}
        {/*          Phone number*/}
        {/*        </label>*/}
        {/*      </div>*/}

        {/*      <div className={style.contact__formItem}>*/}
        {/*        <textarea*/}
        {/*          className={style.contact__formInput}*/}
        {/*          id="form-message"*/}
        {/*          placeholder=" "*/}
        {/*          name="message"*/}
        {/*          onChange={event => setMessage(event.target.value)}*/}
        {/*        />*/}
        {/*        <label*/}
        {/*          className={style.contact__formLabel}*/}
        {/*          htmlFor="form-message"*/}
        {/*        >*/}
        {/*          Please, type your message*/}
        {/*        </label>*/}
        {/*      </div>*/}

        {/*      <div className={style.contact__btnWrap}>*/}
        {/*        <button className={style.contact__formBtn}*/}
        {/*                onClick={submitHandler}*/}
        {/*        >*/}
        {/*          SUBMIT*/}
        {/*        </button>*/}
        {/*      </div>*/}

        {/*      <div className={style.contact__general}>*/}
        {/*        <h3 className={`${style.contact__generalItem} ${style.contact__otherTitle}`}>GENERAL INQUIRIES</h3>*/}
        {/*        <a className={style.contact__generalItem} href="mailto:&#100;&#97;&#110;&#110;&#121;&#64;&#97;&#99;&#117;&#98;&#111;&#115;&#116;&#111;&#110;&#46;&#99;&#111;&#109;">&#100;&#97;&#110;&#110;&#121;&#64;&#97;&#99;&#117;&#98;&#111;&#115;&#116;&#111;&#110;&#46;&#99;&#111;&#109;</a>*/}
        {/*        <a className={style.contact__generalItem} href="tel:+16178602039">tel: 1-617-860-2039</a>*/}
        {/*        <a className={style.contact__generalItem} href="fax:+16178602039">fax: 1-617-608-2836</a>*/}
        {/*      </div>*/}
        {/*    </form>*/}
        {/*  </div>*/}
        {/*</div>*/}
      </div>
  )
}

export default Contact